import "./RunButton.css"
import playIcon from "../../../Images/play.png"
import { useContext, useState, useEffect } from 'react';
import { IDEContext } from '../SolvePage';
import { useLocation } from "react-router-dom";
import { batchedSubmission } from "../../../CodeExecution/Judge0";
import { auth } from "../../../Firebase/InitFirebase";
import MustLoginPopUp from "./MustLoginPopUp";

export default function RunButon({setJudge0APIResponseJSON, isLoading, setIsLoading, selectedLanguage}){
    const { state } = useLocation(); // Unpack { state: { problem_id : problemID } }); 
    const problemID = state.problem_id;    
    const [IDEText, ] = useContext(IDEContext);
    
    const [currentUser, setCurrentUser] = useState(null);

    useEffect(() => {
      const unsubscribe = auth.onAuthStateChanged(user => {
        setCurrentUser(user); 
      });
  
      return () => unsubscribe();
    }, []);


    return(
        <>        
        {!isLoading && 
            <div className="run-button-container">


                    <div className="run-button">
                        <button className="run-code-button" 
                            onClick={
                                async () => {
                                    console.log("LanguageID in RunButton: ", typeof Language)
                                    const user = auth.currentUser;
                                    if (user) {
                                        setIsLoading(true);
                                        setJudge0APIResponseJSON(await batchedSubmission(problemID, user.uid, IDEText, selectedLanguage))
                                        setIsLoading(false);
                                    }
                                }
                            }
                        >
                            <img 
                                src={playIcon} 
                                alt="Play Button" 
                                style={{ 
                                    width: "23px", 
                                    height: "23px", 
                                    objectFit: "cover",
                                    marginTop: "1px",
                                    marginBottom: "auto"
                                }} 
                            />
                        </button>
                    </div>


                    
                    {!currentUser && <MustLoginPopUp />}
            </div>
        }
        </>

    );
}